import script from "./ScrollDelegatesAvatars.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollDelegatesAvatars.vue?vue&type=script&setup=true&lang=js"

import "./ScrollDelegatesAvatars.vue?vue&type=style&index=0&id=46b72fec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b72fec"]])

export default __exports__